import type { MotorPickerEntry } from '../../../utils/electronicsDashboardUtils';
import { useChoosePortsToolbar } from './useChoosePortsToolbar';

/** Header toolbar for multi-port motor stream widgets (`motor`, motor `boolean`). */
export function useChooseMotorsToolbar({
  show,
  isHistoricMode,
  motors,
  selectedPorts,
  onSelectedPortsChange,
  disabled,
  selectedPortsKey,
}: {
  show: boolean;
  isHistoricMode: boolean;
  motors: readonly MotorPickerEntry[];
  selectedPorts: readonly number[];
  onSelectedPortsChange: (ports: number[]) => void;
  disabled?: boolean;
  selectedPortsKey: string;
}) {
  return useChoosePortsToolbar({
    show,
    isHistoricMode,
    entries: motors,
    selectedPorts,
    onSelectedPortsChange,
    disabled,
    selectedPortsKey,
    chooseButtonI18nKey: 'dashboard.motorWidget.chooseMotors',
    chooseButtonDefault: 'Choose Motors',
    chooseAllI18nKey: 'dashboard.motorWidget.chooseAll',
    chooseAllDefault: 'Choose all',
  });
}
